export default __webpack_public_path__ + "static/media/menu-layanan.e0884bb9.svg";